export enum TwitterQueueEnum {
  PRIVATE = 12,
  MENTION = 1,
  PUBLIC_REPLIES = 48,
}
